import {
  CANCEL_MEMBER_REQUEST_ERROR,
  CANCEL_MEMBER_REQUEST_START,
  CANCEL_MEMBER_REQUEST_SUCCESS,
} from 'constants/action-types/groups/cancelMemberRequest';
import notification from 'helpers/notificationHelper';
import apiAction from 'helpers/apiAction';
import getGroupActivities from '../organizations/getGroupActivities';

export default (groupId, requestId, data) => (
  dispatch,
  setPinModal,
) =>
  dispatch(
    apiAction({
      url: `/admin/groups/${groupId}/requests/${requestId}/cancel`,
      method: 'PUT',
      data,
      API_REQUEST_START: CANCEL_MEMBER_REQUEST_START,
      API_REQUEST_SUCCESS: CANCEL_MEMBER_REQUEST_SUCCESS,
      API_REQUEST_FAILURE: CANCEL_MEMBER_REQUEST_ERROR,
      onSuccess: payload => {
        dispatch({
          type: CANCEL_MEMBER_REQUEST_SUCCESS,
          payload,
        });
        setPinModal(false);
        notification({ message: 'Request successfully cancelled' });
        getGroupActivities(groupId, { category: 'no_transactions' })(
          dispatch,
        );
      },
      onFailure: ({ message }) => {
        dispatch({
          type: CANCEL_MEMBER_REQUEST_ERROR,
          payload: message,
        });
        if (message !== 'Wrong PIN.') {
          setPinModal(false);
          notification({ message, status: 'error' });
        }
      },
      onEnd: () => false,
    }),
  );
